export interface CashReceivingResult {
    amount: number;
    status: CashReceivingStatus;
    statusMessage: string;
}

export enum CashReceivingStatus {
    Unknown = -1,
    Disconnected = 0,
    Connecting = 1,
    PupEscrow = 2,
    Idling = 3,
    Accepting = 4,
    Escrow = 5,
    Stacking = 6,
    Stacked = 7,
    Returning = 8,
    Returned = 9,
    Rejected = 10,
    Jammed = 11,
    Stalled = 12,
    Failed = 13,
    CalibrateStart = 14,
    Calibrating = 15,
    DownloadStart = 16,
    DownloadRestart = 17,
    Downloading = 18,
    CassetteRemoved = 19,
    Canceled = 20,
    CashOverflow = 21
}